"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelAccountType = exports.PanelAccountAchievement = exports.PanelAccountTracker = exports.PanelAccountSegment = exports.Account = exports.AccountAchievement = exports.AccountTracker = exports.AccountSegment = exports.tutor_trackerlist = exports.tutor_checklist = exports.limitedTeachableStatues = exports.teachableStatues = void 0;
// tslint:disable: max-classes-per-file
var account_1 = require("../account");
/** Статусы преподавателей */
exports.teachableStatues = [account_1.TeacherStatusEnum.verified, account_1.TeacherStatusEnum.limited_tutor, account_1.TeacherStatusEnum.tutor, account_1.TeacherStatusEnum.teacher, account_1.TeacherStatusEnum.limited_teacher];
exports.limitedTeachableStatues = [account_1.TeacherStatusEnum.limited_tutor, account_1.TeacherStatusEnum.limited_teacher];
exports.tutor_checklist = [account_1.UserSegmentEnum.has_verified_teacher_profile, account_1.UserSegmentEnum.has_user_services, account_1.UserSegmentEnum.has_approved_bank_card, account_1.UserSegmentEnum.use_mobile_app];
exports.tutor_trackerlist = [account_1.UserTrackerEnum.monthly_lessons_published, account_1.UserTrackerEnum.monthly_meetings_provided];
/** @see lingo2-account/src/db/models/account_segment.ts */
var AccountSegment = /** @class */function () {
  function AccountSegment() {}
  return AccountSegment;
}();
exports.AccountSegment = AccountSegment;
/** @see lingo2-account/src/db/models/account_tracker.ts */
var AccountTracker = /** @class */function () {
  function AccountTracker() {}
  return AccountTracker;
}();
exports.AccountTracker = AccountTracker;
/** @see lingo2-account/src/db/models/account_achievement.ts */
var AccountAchievement = /** @class */function () {
  function AccountAchievement() {}
  return AccountAchievement;
}();
exports.AccountAchievement = AccountAchievement;
/** @see lingo2-account/src/db/models/account.ts */
var Account = /** @class */function () {
  function Account() {}
  Object.defineProperty(Account.prototype, "is_guest", {
    get: function () {
      return this.status === account_1.UserStatusEnum.guest;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Account.prototype, "is_teacher", {
    get: function () {
      return exports.teachableStatues.includes(this.teacher_status);
    },
    enumerable: false,
    configurable: true
  });
  return Account;
}();
exports.Account = Account;
var PanelAccountSegment = /** @class */function (_super) {
  __extends(PanelAccountSegment, _super);
  function PanelAccountSegment() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return PanelAccountSegment;
}(AccountSegment);
exports.PanelAccountSegment = PanelAccountSegment;
var PanelAccountTracker = /** @class */function (_super) {
  __extends(PanelAccountTracker, _super);
  function PanelAccountTracker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return PanelAccountTracker;
}(AccountTracker);
exports.PanelAccountTracker = PanelAccountTracker;
var PanelAccountAchievement = /** @class */function (_super) {
  __extends(PanelAccountAchievement, _super);
  function PanelAccountAchievement() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return PanelAccountAchievement;
}(AccountAchievement);
exports.PanelAccountAchievement = PanelAccountAchievement;
var PanelAccountType = /** @class */function (_super) {
  __extends(PanelAccountType, _super);
  function PanelAccountType(values) {
    if (values === void 0) {
      values = {};
    }
    var _this = _super.call(this) || this;
    if (!values) {
      return null;
    }
    var instance = _this;
    Object.keys(values).forEach(function (p) {
      instance[p] = values[p];
    });
    if ('segments' in instance) {
      instance.segments.forEach(function (s) {
        s.created_at = new Date(s.created_at).toISOString();
      });
    }
    if ('trackers' in instance) {
      instance.trackers.forEach(function (t) {
        t.created_at = new Date(t.created_at).toISOString();
        t.due_at = t.due_at ? new Date(t.due_at).toISOString() : null;
        t.passed_at = t.passed_at ? new Date(t.passed_at).toISOString() : null;
      });
    }
    if ('achievements' in instance) {
      instance.achievements.forEach(function (a) {
        a.created_at = new Date(a.created_at).toISOString();
      });
    }
    return _this;
  }
  return PanelAccountType;
}(Account);
exports.PanelAccountType = PanelAccountType;
